<template>
  <div class="p-1">
    <h3>
      {{ title }}

      <router-link v-if="to && to.name" :to="to" style="font-size: 11px;">
        (View)
      </router-link>
    </h3>
    <b-row>
      <b-col v-for="(detail, index) in details" :key="index" cols="12" md="3">
        <dl>
          <dt>{{ detail.title }}</dt>
          <dd>
            {{ detail.value }}
          </dd>
        </dl>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BAlert,
  BOverlay,
  BButton,
  BCard,
  BCol,
  BRow,
  BForm,
  BModal,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BFormTextarea,
  BDropdown,
  BDropdownItem,
  BFormCheckboxGroup,
} from "bootstrap-vue";

export default {
  name: "MemberProfileSection",
  components: {
    BAlert,
    BOverlay,
    BButton,
    BCard,
    BCol,
    BRow,
    BForm,
    BModal,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BFormTextarea,
    BDropdown,
    BDropdownItem,
    BFormCheckboxGroup,
  },
  props: {
    details: {
      type: Array,
      required: true,
      default: () => [],
    },
    title: {
      type: String,
      required: true,
      default: () => "",
    },
    to: {
      type: Object,
      required: false,
      default: () => {},
    },
  }
};
</script>

<style lang="scss" scoped>
dt {
  font-weight: bold;
  margin-bottom: 0;
}
</style>

